<div class="flex gap-4 items-center">
  <div class="rounded-full bg-[#00B2E3] p-1.5 w-8 h-8">
    <img src="/icons/calendar.svg"/>
  </div>
  <div class="font-bold text-2xl">{{title}}</div>
</div>